"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1844],{

/***/ 21844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLimpiezaCircle = function SvgLimpiezaCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M21.192 17.53c0 .299-.258.542-.577.542h-2.307c-.319 0-.577-.243-.577-.543 0-.3.258-.543.577-.543h2.307c.319 0 .577.243.577.543Zm2.308 4.342c0 .3-.258.542-.577.542h-2.308c-.318 0-.576-.243-.576-.542 0-.3.258-.543.576-.543h2.308c.319 0 .577.243.577.543ZM22.346 19.7c0 .3-.258.543-.577.543h-2.307c-.319 0-.577-.243-.577-.543 0-.3.258-.543.577-.543h2.307c.319 0 .577.244.577.543Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.002 18.072a2.538 2.538 0 0 0-.377-1.304 2.745 2.745 0 0 0-1.01-.961l3.982-6.493a.525.525 0 0 0-.211-.741.597.597 0 0 0-.788.198l-4.083 6.655a3.489 3.489 0 0 0-1.623.046 3.339 3.339 0 0 0-1.401.77c-2.16 1.96-1.993 6.543-1.985 6.737a.53.53 0 0 0 .177.37c.107.097.25.151.4.151h8.648c.121 0 .24-.036.338-.102a.546.546 0 0 0 .21-.27.512.512 0 0 0 .003-.333.545.545 0 0 0-.204-.272c-2.043-1.442-2.076-4.422-2.076-4.451Zm-2.927-1.63c.462.005.904.177 1.234.48.33.304.524.716.54 1.15 0 .02 0 .113.01.255l-3.404-1.425a2.24 2.24 0 0 1 .76-.383c.279-.08.571-.105.86-.077Zm2.03 5.972a2.76 2.76 0 0 1-.836-1.628h-1.153c.04.578.233 1.137.558 1.628h-1.282a8.55 8.55 0 0 1-.43-2.17h-1.154c.037.735.166 1.463.383 2.17H9.654c.018-.996.167-3.198 1.04-4.642l4.346 1.818a6.865 6.865 0 0 0 1.304 2.824h-1.238Z",
    fill: "CurrentColor"
  })), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#765346"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgLimpiezaCircle);

/***/ })

}]);